var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.25,
    fill: "#00ADEF",
    fillOpacity: 0.15,
    stroke: "#00ADEF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.52809C14 5.93336 13.842 6.32204 13.5607 6.60861C13.2794 6.89518 12.8978 7.05618 12.5 7.05618C12.1022 7.05618 11.7206 6.89518 11.4393 6.60861C11.158 6.32204 11 5.93336 11 5.52809C11 5.12282 11.158 4.73414 11.4393 4.44757C11.7206 4.16099 12.1022 4 12.5 4C12.8978 4 13.2794 4.16099 13.5607 4.44757C13.842 4.73414 14 5.12282 14 5.52809ZM11.75 9.53933H13.25C13.3531 9.53933 13.4375 9.62528 13.4375 9.73034V20.809C13.4375 20.914 13.3531 21 13.25 21H11.75C11.6469 21 11.5625 20.914 11.5625 20.809V9.73034C11.5625 9.62528 11.6469 9.53933 11.75 9.53933Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/infoIcon.0759ba4c14027fd57cc5648f3e0cca77.svg";
export { ForwardRef as ReactComponent };